module.exports = __webpack_public_path__ + "img/American Samoa.ce249765.svg";